import type { StaticLayoutCarouselProps } from "./static-layout-carousel.type";

import { Carousel } from "antd";

import "./static-layout-carousel.style.less";

export const StaticLayoutCarousel = ({ slides }: StaticLayoutCarouselProps) => {
  const nbr = slides?.length ?? 0;

  return (
    <div>
      <Carousel
        dots={nbr > 1 /* hide dots if only one slide */}
        autoplay={{ dotDuration: true }}
        autoplaySpeed={10000}
        effect="fade"
      >
        {slides?.map(({ key, src }) => (
          <div key={key}>
            <div
              className="static-layout-carousel-slide"
              style={{ backgroundImage: `url(${src})` }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
